import React from 'react';
import DefaultScrollWithHeaderContent from '../../../../utils/DefaultScrollWithHeaderContent';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { AccreditationProcessAPI } from '../../../../../API/accreditationProcess';
import MyTable from '../../../../utils/MyTable';
import allActions from '../../../../../actions';
import { AccreditationProcessCategories } from '../../../rightContent/NewAccreditationProcess';
import moment from 'moment';
import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from '../../../../../controllers/ExcelController';
import { unoTheme } from '../../../../../assets/styles/unoTheme';


const useStyles = makeStyles({
    root: {
        display: 'flex',

        '& .defaultScrollWithHeaderContent': {
            width: "100%",

        }
    },
    sortableHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        whiteSpace: 'nowrap',
    },
});

const getCategoriesLabel = (row) => row.categories_ids
    ? JSON.parse(row.categories_ids).map(id => AccreditationProcessCategories[id]).join(', ')
    : "(Atualizar)";

const getAccreditationDate = (row) => moment.utc(row.validity_date);
const getValidityDate = (row) => moment.utc(row.validity_date).add(2, 'year').subtract(1, 'day');

const SORT_ACCESSORS = {
    process_number: (r) => r.process_number,
    term_number: (r) => r.term_number,
    instituition: (r) => r.instituition,
    categories: (r) => getCategoriesLabel(r),
    accreditation_date: (r) => getAccreditationDate(r).valueOf(),
    validity: (r) => getValidityDate(r).valueOf(),
};

const collator = new Intl.Collator('pt-BR', { numeric: true, sensitivity: 'base' });

const isEmptyValue = (v) => v === null || v === undefined || v === '' || (typeof v === 'number' && isNaN(v));

export default function AccreditedInstitutionsTab(props) {

    const { selectedYear } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const rightContent = useSelector(state => state.rightContent)

    const [listAccreditationProcesses, setListAccreditationProcesses] = React.useState([]);

    //Ordenação: por padrão alfabética (asc) por nome da instituição
    const [orderBy, setOrderBy] = useState('instituition');
    const [order, setOrder] = useState('asc');

    const loadAccreditationProcesses = async (clientId) => {
        const response = await AccreditationProcessAPI.getAllByClientId(clientId);
        console.log("response: ", response);
        if (response.body.rows.length === 0) {
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Nenhuma instituição credenciada cadastrada' }));
        } else {
            setListAccreditationProcesses(response.body.rows);
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }

    useEffect(() => {

        if (!clientOn?.client?.id) return;
        loadAccreditationProcesses(clientOn.client.id);

    }, [clientOn?.client?.id]);

    useEffect(() => {
        if (rightContent && rightContent.action) {
            dispatch(allActions.rightContentActions.setRightContent(null))
            loadAccreditationProcesses(clientOn.client.id);
        }
    }, [rightContent])

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === 'asc' ? 'desc' : 'asc');
        } else {
            setOrderBy(column);
            setOrder('asc');
        }
    };

    const SortIcon = ({ column }) => {
        if (orderBy !== column) return <ArrowDropDown style={{ color: '#ccc' }} />;
        return order === 'asc'
            ? <ArrowDropUp style={{ color: unoTheme.mainColor }} />
            : <ArrowDropDown style={{ color: unoTheme.mainColor }} />;
    };

    //Única fonte das linhas exibidas: filtro de ano + ordenação (usada também na exportação)
    const sortedRows = useMemo(() => {

        const rows = listAccreditationProcesses.filter(el =>
            selectedYear == "TODOS" || moment.utc(el.validity_date).format('YYYY') == selectedYear);

        if (!orderBy) return rows;

        const accessor = SORT_ACCESSORS[orderBy];
        const dir = order === 'asc' ? 1 : -1;

        return [...rows].sort((ra, rb) => {
            const a = accessor(ra), b = accessor(rb);
            const aEmpty = isEmptyValue(a), bEmpty = isEmptyValue(b);
            //vazios sempre no fim, independente da direção
            if (aEmpty || bEmpty) return aEmpty && bEmpty ? 0 : (aEmpty ? 1 : -1);
            if (typeof a === 'number' && typeof b === 'number') return (a - b) * dir;
            return collator.compare(String(a), String(b)) * dir;
        });

    }, [listAccreditationProcesses, selectedYear, orderBy, order]);

    const doReport = useCallback(() => {
        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: 'accreditationProcesses',
            reportData: listAccreditationProcesses.map((el) => ({
                ...el,
                categories: getCategoriesLabel(el),
                validity_date: getValidityDate(el).format('DD/MM/YYYY')
            })),
            message: 'Gerando relatório...'
        }))
    }, [listAccreditationProcesses, selectedYear]);

    const doExcel = useCallback(() => {

        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Gerando planilha...' }));

        const sheetName = 'Instituições Credenciadas';
        const wb = XLSX.utils.book_new();
        wb.Props = { Title: sheetName, Author: 'UNO' };
        wb.SheetNames.push(sheetName);

        const ws_data = [[
            'Nº DO PROCESSO', 'Nº DO TERMO/ATESTADO', 'INSTITUIÇÃO', 'CNPJ',
            'CATEGORIAS', 'DATA DE CREDENCIAMENTO', 'VALIDADE',
        ]];

        sortedRows.forEach(row => ws_data.push([
            row.process_number,
            row.term_number,
            row.instituition,
            row.cnpj,
            getCategoriesLabel(row),
            getAccreditationDate(row).format('DD/MM/YYYY'),
            getValidityDate(row).format('DD/MM/YYYY'),
        ]));

        wb.Sheets[sheetName] = XLSX.utils.aoa_to_sheet(ws_data);
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        const fileName = `instituicoes_credenciadas_${selectedYear === 'TODOS' ? 'todos' : selectedYear}`;
        downloadBlob(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), fileName + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));

    }, [sortedRows, selectedYear, dispatch]);

    useEffect(() => {
        window.addEventListener('doReportAccreditationProcesses', doReport);
        window.addEventListener('doExcelAccreditationProcesses', doExcel);
        return () => {
            window.removeEventListener('doReportAccreditationProcesses', doReport);
            window.removeEventListener('doExcelAccreditationProcesses', doExcel);
        };
    }, [doReport, doExcel])


    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={null}>

                <MyTable
                    selectable="true"
                    stickyHeader
                    size="small">
                    {/* <colgroup>
                        <col width="20%" />

                    </colgroup> */}
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" onClick={() => handleSort('process_number')}>
                                <div className={classes.sortableHeader} style={{ justifyContent: 'center' }}>
                                    Nº do processo <SortIcon column="process_number" />
                                </div>
                            </TableCell>
                            <TableCell align="center" onClick={() => handleSort('term_number')}>
                                <div className={classes.sortableHeader} style={{ justifyContent: 'center' }}>
                                    Nº do termo/atestado <SortIcon column="term_number" />
                                </div>
                            </TableCell>
                            <TableCell className="ellipsis" align="left" onClick={() => handleSort('instituition')}>
                                <div className={classes.sortableHeader} style={{ justifyContent: 'flex-start' }}>
                                    Instituição <SortIcon column="instituition" />
                                </div>
                            </TableCell>
                            <TableCell align="left">CNPJ</TableCell>
                            <TableCell align="left" onClick={() => handleSort('categories')}>
                                <div className={classes.sortableHeader} style={{ justifyContent: 'flex-start' }}>
                                    Categorias <SortIcon column="categories" />
                                </div>
                            </TableCell>
                            <TableCell align="center" onClick={() => handleSort('accreditation_date')}>
                                <div className={classes.sortableHeader} style={{ justifyContent: 'center' }}>
                                    Data de credenciamento <SortIcon column="accreditation_date" />
                                </div>
                            </TableCell>
                            <TableCell align="center" onClick={() => handleSort('validity')}>
                                <div className={classes.sortableHeader} style={{ justifyContent: 'center' }}>
                                    Validade <SortIcon column="validity" />
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedRows.map((row) => (

                            <TableRow key={"accreditation-process-" + row.id} onClick={
                                () => dispatch(allActions.rightContentActions.setRightContent({
                                    path: 'newAccreditationProcess',
                                    update: true,
                                    data: { ...row }
                                }))
                            }>
                                <TableCell align="center">{row.process_number}</TableCell>
                                <TableCell align="center">{row.term_number}</TableCell>
                                <TableCell align="left" className="ellipsis">{row.instituition}</TableCell>
                                <TableCell align="left">{row.cnpj}</TableCell>
                                <TableCell align="left">{getCategoriesLabel(row)}</TableCell>
                                <TableCell align="center">{
                                    getAccreditationDate(row).format('DD/MM/YYYY')
                                }</TableCell>
                                <TableCell align="center" style={{
                                    color: getValidityDate(row).isBefore(moment.utc(new Date())) ? 'red' : 'green'
                                }}>{
                                        getValidityDate(row).format('DD/MM/YYYY')
                                    }</TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </MyTable>
            </DefaultScrollWithHeaderContent>

        </div>
    );
}
